interface CartElement extends Element {
  updateQuantity: (index: string, quantity: number, event: Event, itemKey: string) => void;
  removeWarrantyAndItemQuantity: (
    index: string,
    itemKey: string,
    warrantyKeys: string[],
    event: Event,
    variantId: string,
  ) => void;
}
export default class CartRemoveButton extends HTMLElement {
  private cartItems: CartElement | null = null;
  private itemKey: string | null = null;

  constructor() {
    super();
    this.initializeElements();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  private initializeElements(): void {
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    this.itemKey = this.dataset.itemKey || null;
  }

  private handleClick(event: Event): void {
    event.preventDefault();

    if (!this.cartItems || !this.itemKey) return;

    const relatedWarrantyItems = Array.from(
      this.cartItems.querySelectorAll<HTMLElement>('[data-warranty-item="true"]'),
    ).filter((item) => item.getAttribute('data-linked-item-key') === this.itemKey);

    try {
      if (relatedWarrantyItems.length > 0) {
        const warrantyKeys = relatedWarrantyItems
          .map((item) => item.dataset.itemKey)
          .filter((key): key is string => Boolean(key));

        if (typeof this.cartItems?.updateQuantity === 'function') {
          const itemIndex = this.dataset.index;
          const variantId = this.dataset.variantId || '';
          if (itemIndex) {
            this.cartItems.removeWarrantyAndItemQuantity(itemIndex, this.itemKey, warrantyKeys, event, variantId);
          }
        }
      } else {
        this.removeCartItem(event);
      }
    } catch {
      const lineItemErrors = document.querySelectorAll(`#CartItem-LineItemError-${this.dataset.index}`);
      lineItemErrors.forEach((lineItemError) => {
        const errorText = lineItemError?.querySelector('.cart-item__error-text');
        if (errorText) {
          errorText.textContent = 'There was a problem removing the warranty item';
        }
      });
    }
  }

  private removeCartItem(event: Event): void {
    const index = this.dataset.index;

    if (!this.itemKey || !index) {
      return;
    }

    if (typeof this.cartItems?.updateQuantity === 'function') {
      this.cartItems.updateQuantity(index, 0, event, this.itemKey);
    }
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}
